import React from "react";
import Modal from "react-modal";
import "./QuickViewModal.css";

Modal.setAppElement("#root");

export const QuickViewModal = ({ isOpen, onClose, product }) => {
  if (!product) return null;
  const p = product;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      className="modal-body"
    >
      <button className="modal-close" onClick={onClose}>✕</button>
      <div className="quickview-content">
        <div className="quickview-left">
          <img src={p.image || "/assets/product-placeholder.png"} alt={p.name} />
        </div>
        <div className="quickview-right">
          <h3>{p.name}</h3>
          <p className="meta">{p.category?.name || p.categoryName || ""}</p>
          <div className="price">
            ₹{p.discountedPrice ? p.discountedPrice : p.price}
            {p.discountPercent > 0 && (
              <span style={{ color: "red", marginLeft: "8px", fontSize: "0.95em" }}>
                <del>₹{p.price}</del> ({p.discountPercent}% OFF)
              </span>
            )}
          </div>
          <p className="desc">{p.description}</p>
        </div>
      </div>
    </Modal>
  );
};

export default QuickViewModal;
